import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, getLinkTo, title, groups } = appSections.shipping;
export const shippingRoute = {
    path: rootPath,
    lazy: async () => {
        const { ShipmentsContainer } = await import('@/warehouse/modules/shipping');
        return {
            element: (_jsx(ProtectedRoute, { groups: groups, children: _jsx(ShipmentsContainer, {}) })),
        };
    },
    handle: {
        crumb: ({ params: { crossDockId } }) => _jsx(NavLink, { to: getLinkTo(crossDockId), children: title }),
    },
};
